/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const ProviderEligibility = {
        PaidVisibility: 'PAID_VISIBILITY',
        Promotion: 'PROMOTION'
} as const;
export type ProviderEligibility = typeof ProviderEligibility[keyof typeof ProviderEligibility];

